
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns383c28a7c257fdd08be6a95eeeea79efen from './en.yaml'
            i18n.addResourceBundle('en', '383c28a7c257fdd08be6a95eeeea79ef', flattenObject(ns383c28a7c257fdd08be6a95eeeea79efen), true, true);
        
        export default '383c28a7c257fdd08be6a95eeeea79ef';
    